export const textWrapperTemplate = ({ color, font, fontSize, anchor, position, content }) => `
  <g class="text" fill="${color}" font-family="${font}" font-size="${fontSize}" text-anchor="${anchor}">
    <text class="eol" x="${position.x}" y="${position.y + fontSize}">${content}</text>
  </g>`;

export const textAreaWrapperTemplate = ({ headingId, rectId, position, size, textWrapper }) => `
  <g id="${headingId}" class="element textarea" data-meta="page-heading">
    <rect id="${rectId}" x="${position.x}" y="${position.y}" width="${size.width}" height="${size.height}" fill="none"></rect>
    ${textWrapper}
  </g>`;
